import { render, staticRenderFns } from "./ParsingSettings.vue?vue&type=template&id=544559fa&scoped=true"
import script from "./ParsingSettings.vue?vue&type=script&lang=ts"
export * from "./ParsingSettings.vue?vue&type=script&lang=ts"
import style0 from "./ParsingSettings.vue?vue&type=style&index=0&id=544559fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544559fa",
  null
  
)

export default component.exports